import { VBPopover } from './popover';
import { pluginFactory } from '../../utils/plugins';
var VBPopoverPlugin = /*#__PURE__*/pluginFactory({
  directives: {
    VBPopover: VBPopover
  }
});
export { VBPopoverPlugin, VBPopover };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/directives/popover/index.js
// module id = 135
// module chunks = 0